import OpenInNewIcon from "@mui/icons-material/OpenInNew"

import { event } from "./auth"
import { release } from "./release"
import { useAppSizeContext } from "./context/AppSizeContext"

const SOURCES = [
  {
    name: "Grand Archive Index",
    slug: "index",
    url: "https://index.gatcg.com",
    description:
      "The official Grand Archive card database. All card data, editions, " +
      "legality, and images in this app come from its API.",
  },
  {
    name: "fractalofin.site",
    slug: "fractalofin",
    url: "https://fractalofin.site",
    description:
      "Community-run tournament tracker. Its appearance counts and win " +
      "rates power the Metagame tiers and win-rate pills.",
  },
  {
    name: "TCGplayer",
    slug: "tcgplayer",
    url: "https://www.tcgplayer.com",
    description:
      "Marketplace for singles and sealed product. Powers card prices, " +
      "set values, and the buy links throughout the app.",
  },
]

function SourceLink({ src }) {
  return (
    <a
      className="ack-link"
      href={src.url}
      target="_blank"
      rel="noreferrer"
      title={src.description}
      onClick={() => event(`ack-${src.slug}`, "/champions")}
    >
      {src.name}
      <OpenInNewIcon sx={{ fontSize: 10 }} />
    </a>
  )
}

export default function Acknowledgements() {
  const { isSmall } = useAppSizeContext()
  return (
    <div className="acks">
      <p className="acks-line">
        Built with card data from <SourceLink src={SOURCES[0]} />, tournament
        stats from <SourceLink src={SOURCES[1]} />, and prices from{" "}
        <SourceLink src={SOURCES[2]} />.
      </p>
      <div className="acks-rule" aria-hidden="true" />
      <div className="acks-note">
        Grand Archive Helper is an unofficial fan project. Card images and
        game content © Weebs of the Shore.
      </div>
      {/* phones have no header tooltip for this (no hover, tight
          space next to the corner buttons) — show it inline */}
      {isSmall && <div className="acks-note">Last updated: {release}</div>}
    </div>
  )
}
